/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectBYOApps200Response {
  /**
  * Status message
  */
  'message'?: string;
  /**
  * Temporal workflow ID for tracking setup progress
  */
  'workflowId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "message",
      "baseName": "message",
      "type": "string",
      "format": ""
    },
    {
      "name": "workflowId",
      "baseName": "workflowId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectBYOApps200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

